<template>
    <div class="p-grid">
        <div class="p-lg-4 p-sm-6 p-col-12">
            <CustomInputText name="name" label="Nazwa" v-model="internalValue.name"/>
        </div>
        <div class="p-lg-4 p-sm-6 p-col-12">
            <CustomSelectOneCategoryType name="type" label="Typ kategorii"
                                         v-model="internalValue.type"/>
        </div>
    </div>
</template>

<script>
    import CustomSelectOneCategoryType from "@/components/form/CustomSelectOneCategoryType";
    import CustomInputText from "../../../components/form/CustomInputText";

    export default {
        name: "PostCategorySearchCriteria",

        props: {
            modelValue: null,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        components: {CustomSelectOneCategoryType, CustomInputText},
    };
</script>

<style lang="less" scoped>

</style>
